import { render } from "./AccompagnementSection.vue?vue&type=template&id=02112d59&scoped=true"
const script = {}

import "./AccompagnementSection.vue?vue&type=style&index=0&id=02112d59&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02112d59"]])

export default __exports__